import Paragraph from "@components/CustomTypography/Paragraph/Paragraph"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useEffect} from "react"

type Props = {
	data: AdvancedSideAssetModuleType
}

const OnePricingSection = (props: Props) => {
	useEffect(() => {
		const script = document.createElement("script")
		script.src = "/pricingTableBundle2.js"
		script.async = true
		document.body.appendChild(script)
		return () => {
			document.body.removeChild(script)
		}
	}, [])
	return (
		<>
			<Title content={props.data.sectionTitle} size={"XL"} center />
			<Separator size={64} />
			<div id={"first-one-prices"} />
			<Paragraph
				content={props.data.sectionBottomSubtitle}
				size={"XS"}
				style={{
					marginTop: "1rem",
					fontSize: "13px",
				}}
			/>
		</>
	)
}

export default OnePricingSection
